// 不織袋 (再利用可)追加制御
jQuery(function( $ ){
  function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }

  $.getJSON('/cart.js', function(cart) {
    if (cart.items.length) {
      $.each(cart.items, function(idx, obj){
        if (obj.product_title == '不織袋') {
          $('#addOption').prop('checked', true);
        }
      });
      $('.product-toption').css('opacity', '1');
    } else {
      $('.product-toption').css('opacity', '1');
    }
  });

  $( ".option-des-open" ).click(function() {
    $(".option-des").css("display", "block");
  });

  $( ".option-des-close" ).click(function() {
    $(".option-des").css("display", "none");
  });

  $('#addOption').click(function(){
    if($(this).prop("checked") == true){
      $.getJSON('/cart.js', function(cart) {
        let indexOption = cart.items.findIndex(item => item.id == '37851050246339');
        if (indexOption != -1) {
          $('#CartCount span:first-child').html(cart.item_count);
          var cartSubTotal = cart.total_price/100;
          $('.cart__footer .cart-subtotal .cart-subtotal__price').html('¥' + formatNumber(cartSubTotal) + ' (税込)');
        } else {
          let dataProduct = [ {
            quantity: 1,
            id: '37851050246339'
          } ];

          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              items: dataProduct
            },
            dataType: 'json',
            beforeSend: function() {
            },
            success: function (data) {
              $.getJSON('/cart.js', function(cart) {
                $('#CartCount span:first-child').html(cart.item_count);
                var cartSubTotal = cart.total_price/100;
                $('.cart__footer .cart-subtotal .cart-subtotal__price').html('¥' + formatNumber(cartSubTotal) + ' (税込)');
              });
            },
            error: function(xhr, status, error) {
              var errors = xhr.responseJSON;
            }
          });
        }
      });
    }
    else if($(this).prop("checked") == false){
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          quantity: 0,
          id: '37851050246339'
        },
        dataType: 'json',
        success: function (data) {
          $.getJSON('/cart.js', function(cart) {
            $('#CartCount span:first-child').html(cart.item_count);
            var cartSubTotal = cart.total_price/100;
            $('.cart__footer .cart-subtotal .cart-subtotal__price').html('¥' + formatNumber(cartSubTotal) + ' (税込)');

            if (cart.item_count === 0) {
              window.location.reload();
            }
          });
        },
        error: function(xhr, status, error) {
          var errors = xhr.responseJSON;
        }
      });
    }
  });
});


// 注意書きモーダル および ストアからのお知らせモーダル
document.addEventListener('DOMContentLoaded', function() {
  const modalTriggers = document.querySelectorAll('[data-modal-trigger]');
  const allModals = document.querySelectorAll('[data-modal]'); // 全てのモーダルを取得
  const modalCloseButtons = document.querySelectorAll('[data-modal-close]');

  // 開く処理 (ターゲットモーダルを引数に追加)
  function openModal(targetModal) {
    if (!targetModal) return; // モーダルが見つからない場合は何もしない
    const modalContent = targetModal.querySelector('.cart-caution-modal__content');
    targetModal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (modalContent) { // modalContentが存在する場合のみスタイル適用
      setTimeout(() => {
        modalContent.style.opacity = '1';
        modalContent.style.transform = 'translateY(0)';
      }, 10);
    }
  }

  // 閉じる処理 (ターゲットモーダルを引数に追加)
  function closeModal(targetModal) {
    if (!targetModal) return; // モーダルが見つからない場合は何もしない
    const modalContent = targetModal.querySelector('.cart-caution-modal__content');
    if (modalContent) { // modalContentが存在する場合のみスタイル適用
      modalContent.style.opacity = '0';
      modalContent.style.transform = 'translateY(-20px)';
    }
    setTimeout(() => {
      targetModal.classList.remove('is-open');
      // 他に開いているモーダルがないか確認
      const anyModalOpen = Array.from(allModals).some(m => m.classList.contains('is-open'));
      if (!anyModalOpen) {
        document.body.style.overflow = ''; // 他に開いているモーダルがなければ overflow を戻す
      }
    }, 300); 
  }

  // トリガーボタンのイベントリスナー
  modalTriggers.forEach(trigger => {
    trigger.addEventListener('click', function() {
      const modalId = this.getAttribute('data-modal-trigger'); // トリガーの値を取得
      const targetModal = document.querySelector(`[data-modal="${modalId}"]`); // 対応するモーダルを取得
      openModal(targetModal); // 取得したモーダルを開く
    });
  });

  // 閉じるボタンのイベントリスナー
  modalCloseButtons.forEach(button => {
    button.addEventListener('click', function() {
      const targetModal = this.closest('[data-modal]'); // 親のモーダル要素を取得
      closeModal(targetModal); // そのモーダルを閉じる
    });
  });

  // モーダルの外側クリックで閉じる (全てのモーダルに適用)
  allModals.forEach(modal => {
    modal.addEventListener('click', function(e) {
      // オーバーレイ部分がクリックされた場合のみ閉じる
      if (e.target === modal || e.target.classList.contains('cart-caution-modal__overlay')) {
        closeModal(modal);
      }
    });
    // モーダルコンテンツ内のクリックイベントの伝播を停止
    const modalContent = modal.querySelector('.cart-caution-modal__content');
    if(modalContent){
      modalContent.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    }
  });


  // ESCキーで現在開いているモーダルを閉じる
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const openModalElement = document.querySelector('.cart-caution-modal.is-open'); // 開いているモーダルを取得
      if (openModalElement) {
        closeModal(openModalElement);
      }
    }
  });

});


// カートページの数量変更ボタン制御
document.addEventListener('DOMContentLoaded', function() {
  const cartForm = document.querySelector('#cart');
  if (!cartForm) return;

  // 数量変更ボタンのイベントリスナー
  cartForm.addEventListener('click', function(evt) {
    if (evt.target.matches('[data-minus-qtt]') || evt.target.matches('[data-plus-qtt]')) {
      evt.preventDefault();
      handleQuantityChange(evt);
    }
  });

  function handleQuantityChange(evt) {
    const quantityWrapper = evt.target.closest('.cart__qty-input-wrapper');
    if (!quantityWrapper) return;

    const input = quantityWrapper.querySelector('.cart__qty-input');
    const currentValue = parseInt(input.value, 10);
    let newValue = currentValue;

    if (evt.target.matches('[data-plus-qtt]')) {
      newValue = currentValue + 1;
    } else if (evt.target.matches('[data-minus-qtt]')) {
      newValue = Math.max(0, currentValue - 1);
    }

    // 3個までの制限チェック
    if (newValue > 3) {
      const cartRow = evt.target.closest('.cart__row');
      const productTitle = cartRow ? cartRow.getAttribute('data-cart-item-title') : '';
      alert(`${productTitle || 'この商品'}は3点までしか購入できません。`);
      input.value = currentValue;
      
      // 現在の値が3を超えている場合は3に修正
      if (currentValue > 3) {
        input.value = 3;
        updateItemQuantity(input, 3);
      }
      return;
    }

    if (newValue !== currentValue) {
      input.value = newValue;
      updateItemQuantity(input, newValue);
    }
  }

  function updateItemQuantity(input, newQuantity) {
    
    const cartRow = input.closest('.cart__row');
    if (!cartRow) return;

    const quantityWrapper = input.closest('.cart__qty-input-wrapper');
    
    // ローディングクラスを追加
    if (quantityWrapper) {
      quantityWrapper.classList.add('is-loading');
    }

    const changeEvent = new Event('change', { bubbles: true });
    input.dispatchEvent(changeEvent);
  }
});


// GWP進捗バー更新処理
const updateGWPProgressBar = (cart_total_price) => {
  const progressBar = document.querySelector('[data-gwp-progress]');
  const progressBarData = document.getElementById('gwp-progress-bar-data');
  if (!progressBar || !progressBarData) return;

  const progressBarDataJSON = JSON.parse(progressBarData.textContent);
  const targetAmount = parseInt(progressBarDataJSON.gwp_progress);
  const progressText = progressBarDataJSON.gwp_progress_text;
  const completedText = progressBarDataJSON.gwp_completed_text;
  console.log("cart_total_price",cart_total_price);
  
  const currentAmount = cart_total_price;
  const progressPercent = Math.min((currentAmount / targetAmount) * 100, 100);
  const remaining = targetAmount - currentAmount;
  
  // DOM要素の取得
  const fillElement = progressBar.querySelector('[data-gwp-fill]');
  const remainingElement = progressBar.querySelector('[data-gwp-remaining]');
  
  // 進捗バーの更新
  if (fillElement) {
    fillElement.style.width = progressPercent + '%';
  }
  
  // ステータステキストの更新
  if (currentAmount >= targetAmount) {
    if (remainingElement) remainingElement.textContent = completedText;
    progressBar.classList.add('is-completed');
  } else {
    if (remainingElement) {
      const remainingYen = Math.floor(remaining / 100);
      // {amount}を残り金額に置換
      const displayText = progressText.replace('[amount]', `¥${remainingYen.toLocaleString()}`);
      remainingElement.textContent = displayText;
    }
    progressBar.classList.remove('is-completed');
  }
};

// 送料無料バー更新処理
const updateFreeShippingProgressBar = (cart_total_price) => {
  const progressBarArea = document.querySelector('[data-progress-bar-area]');
  const progressBar = document.querySelector('[data-shipping-free-progress]');
  const progressBarData = document.getElementById('shipping-free-progress-bar-data');
  if (!progressBar || !progressBarData) return;

  const progressBarDataJSON = JSON.parse(progressBarData.textContent);
  const targetAmount = parseInt(progressBarDataJSON.free_shipping_progress);
  const freeShippingMemberFlg = progressBarDataJSON.free_shipping_member_flg;
  const currentAmount = cart_total_price;

  let progressText = '';
  let completedText = '';
  let progressPercent = 0;
  let remaining = 0;
  
  if(freeShippingMemberFlg === true){
    progressPercent = 100;
    remaining = 0;
    progressText = progressBarDataJSON.shipping_free_completed_text;
    completedText = progressBarDataJSON.shipping_free_completed_text;
  } else {
    progressPercent = Math.min((currentAmount / targetAmount) * 100, 100);
    remaining = targetAmount - currentAmount;
    progressText = progressBarDataJSON.shipping_free_progress_text;
    completedText = progressBarDataJSON.shipping_free_completed_text;
  }

  // DOM要素の取得
  const fillElement = progressBar.querySelector('[data-shipping-free-fill]');
  const remainingElement = progressBar.querySelector('[data-shipping-free-remaining]');
  
  // 進捗バーの更新
  if (fillElement) {
    fillElement.style.width = progressPercent + '%';
  }
  
  // ステータステキストの更新
  const rewardElement = progressBarArea.querySelector('[data-gwp-progress]');
  if (currentAmount >= targetAmount) {
    // 条件達成でバーを非表示
    progressBar.setAttribute('hidden', 'hidden');
    if(!rewardElement) {
      progressBarArea.setAttribute('hidden', 'hidden');
    }
    if (remainingElement) remainingElement.textContent = completedText;
    progressBar.classList.add('is-completed');
  } else {
    // 条件未達成でバーを表示
    progressBar.removeAttribute('hidden');
    if(!rewardElement) {
      progressBarArea.removeAttribute('hidden');
    }
    if (remainingElement) {
      const remainingYen = Math.floor(remaining / 100);
      // {amount}を残り金額に置換
      const displayText = progressText.replace('[amount]', `¥${remainingYen.toLocaleString()}`);
      remainingElement.textContent = displayText;
    }
    progressBar.classList.remove('is-completed');
  }
};

